<template>
  <div class="xcard">
    <h4 class="text-center">Plataformas</h4>
    <p class="text-center">Plataformas disponibles</p>

    <button class="btn btn-sm btn-link" @click="agregar()" data-toggle="modal" data-target="#modalpla">
      <span class="glyphicon glyphicon-plus"></span> Agregar
    </button>

    <button class="btn btn-sm btn-link" @click="getDatos">
      <span class="glyphicon glyphicon-refresh"></span> Actualizar
    </button>
    <Alertas ref="xalertar" />

    <div class="table-responsive">
      <table ref="table" class="table table-condensed table-striped table-hover" id="midatatable">
        <thead style="background: #196391">
          <tr class="white--text">
            <th>Nro</th>
            <th>Nombre</th>
            <th>Direccion</th>
            <th>Estado</th>
            <th>Token</th>
            <th style="min-width: 120px">Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(pla, ind) in plataformas">
            <td>{{ ind + 1 }}</td>
            <td>{{ pla.nombre }}</td>
            <td>{{ pla.direccion }}</td>
            <td class="text-center"><span :class="'' + pla.estado"></span></td>
            <td>{{ pla.token }}</td>
            <td>
              <button
                :disabled="!$store.state.deleteInscripcion"
                type="button"
                class="btn btn-sm btn-default"
                @click="confirmarEliminacion(pla)">
                <span class="glyphicon glyphicon-trash"></span>
              </button>
              <button
                :disabled="!$store.state.deleteInscripcion"
                type="button"
                class="btn btn-sm btn-default"
                @click="editar(pla)"
                data-toggle="modal"
                data-target="#modalpla">
                <span class="glyphicon glyphicon-pencil"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Modal id="modalpla" :obj="objeto" v-on:exito="modalExito" />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import Modal from '@/components/APlataformaModal.vue';
import Alertas from '@/components/AAlertas.vue';
import { parseJsonError } from '@/components/Utils.js';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      objeto: { xtitle: '', xid: 0, xeliminar: false },
      // plataformas: [],
    };
  },
  components: { Alertas, Modal },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.getDatos();
    },
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      plataformas: (state) => {
        if (state.UNIDAD_NEGOCIO_ID) {
          return state.plataforma.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID);
        }
        return [];
      },
    }),
  },
  methods: {
    modalExito() {
      this.getDatos();
    },
    agregar() {
      this.objeto.xtitle = 'Registrar Nueva Plataforma';
    },
    editar(pla) {
      this.objeto.xid = pla.id;
      this.objeto.xnombre = pla.nombre;
      this.objeto.xdireccion = pla.direccion;
      this.objeto.xtoken = pla.token;
    },
    confirmarEliminacion(pla) {
      const eliminaPlataforma = window.confirm(
        `¿Está seguro de eliminar la plataforma ${pla.nombre} ${pla.direccion}?`,
      );

      if (eliminaPlataforma) {
        this.eliminar(pla.id);
      }
    },
    getDatos() {
      this.$refs.xalertar.cargando();

      axios
        .get(`${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas`)
        .then((response) => {
          const data = response?.data;
          const plataformas = data?.datos?.map((plataforma) => {
            const { unidadNegocioId, ...resto } = plataforma;
            return {
              ...resto,
              unidad_negocio_id: unidadNegocioId,
            };
          });

          this.$store.dispatch('plataforma/setPlataformas', plataformas);
          this.$refs.xalertar.reset();
        })
        .catch((error) => {
          window.console.error(error);
          this.$notify(parseJsonError(error, 'misInscripciones'));
        })
        .finally(() => {
          this.$refs.xalertar.reset();
        });
    },
    eliminar(plataformaId) {
      this.$refs.xalertar.cargando();

      axios
        .delete(`${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${plataformaId}`)
        .then((response) => {
          const data = response?.data;
          const mensaje = data?.mensaje;

          this.$refs.xalertar.success();
          this.$root.$notify.show(mensaje, { color: 'green' });
        })
        .catch((error) => {
          window.console.error(error);
          const response = error?.response;
          const data = response?.data;
          const mensaje = data?.mensaje;

          this.$root.$notify.show(mensaje, { color: 'red' });
        })
        .finally(() => {
          this.$refs.xalertar.reset();
          this.getDatos();
        });
    },
  },
  mounted() {
    this.getDatos();
  },
};
</script>
<style scoped>
.true {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background: green;
}
.false {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background: red;
}
</style>
